module.exports = __webpack_public_path__ + "img/main_header_btm.41cb8cfc.png";